import React from "react";
import { useTranslation } from "react-i18next";
import SliderCard from "../../../../components/SliderCard";
import WPHeading from "../../../../packages/WPHeading";
import IconWithTooltip from "../../../../common/styles/components/headings/IconWithTooltip";
import { outlierConfig } from "../AdvancedSettings.config";

const OutlierRemoval = ({
  suggestedSettings,
  resetKey,
  settings,
  defaultSettings,
  handleChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="info-section">
        <WPHeading fontNoto size="small">{t("advanceSettings.outlierRemoval")}</WPHeading>
        <IconWithTooltip label={t("helpInformation.outlierRemovalHelp")} />
      </div>
      <div className="slider-cards-group">
        {Object.keys(outlierConfig).map((key) => {
          const config = outlierConfig[key];
          const isRecommended = suggestedSettings[key] != null;
          return (
            <div className="slider-card-container" key={config.key}>
              <SliderCard
                key={`${config.key}-${resetKey}`}
                id={config.key}
                label={t(`advanceSettings.${config.key}`)}
                min={config.minValue}
                max={config.maxValue}
                recommended={isRecommended ? suggestedSettings[key] : null}
                isInteger={config.isInteger}
                maxLength={config.maxLength}
                inputValue={settings[key] ?? defaultSettings[key]}
                leftLabel={config.leftLabelKey ? t(`advanceSettings.${config.leftLabelKey}`) : undefined}
                rightLabel={config.rightLabelKey ? t(`advanceSettings.${config.rightLabelKey}`) : undefined}
                onChange={(val) =>
                  handleChange({
                    type: "slider",
                    key,
                    value: val,
                    min: config.ranges.hard.min,
                    max: config.ranges.hard.max,
                  })
                }
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default OutlierRemoval;
